<!-- =========================================================================================
    File Name: KnowledgeBase.vue
    Description: Knowledge Base Page

========================================================================================== -->


<template>
  <div>
    <div class="rounded-lg w-full"
         style="background-image: url(https://cdn.discordapp.com/attachments/733851758211629347/954057924391600218/BG.png);
         box-shadow: 0px 4px 25px 0px rgba(0,0,0,.1);">
      <div class="knowledge-base-jumbotron-content lg:p-12 sm:p-10 p-8 rounded-lg mb-4"
           style="backdrop-filter: blur(10px); height: 100%;">
        <h5 class="font-light text-white">Apps Launcher</h5>
        <h1 class="mb-1 text-white font-bold" style="font-size: 2.9rem">Select an App to Launch</h1>
      </div>
    </div>
    <div v-if="apps.length">
      <slide-x-left-transition group class="vx-row match-height" tag="div">
        <div v-for="app in apps" :key="app.id" class="vx-col card-width-app mb-base">
          <app-card :app="app"/>
        </div>
      </slide-x-left-transition>
    </div>
    <div class="simple-spinner" v-else>
      <span></span>
    </div>

  </div>
</template>

<!--suppress ES6ShorthandObjectProperty -->
<script>
import AppCard from './components/AppCard'

export default {
  data () {
    return {
      apps: []
    }
  },
  components: {
    AppCard
  },
  methods: {
    fetchAppsList () {

      if (this.activeCourseInfo.selected === false) {
        this.$vs.notify({
          title: 'No Course Selected',
          text: 'Please select a courses before practicing',
          color: 'danger',
          position: 'top-right'
        })
        return this.$router.push('/courses')
      }

      this.$http.get('app/platform/apps')
        .then(response => {

          if (response.status === 200) {
            this.apps = response.data.data
          }

        })
        .catch(() => {
        })
    }
  },
  beforeMount () {
    this.fetchAppsList()
  },
  computed: {
    activeCourseInfo () {
      return this.$store.state.AppActiveCourse
    }
  }
}
</script>


<style lang="scss">

.card-width-app {
  width: 20%;
}

@media (max-width: 2200px) {
  .card-width-app {
    width: 25%;
  }
}

@media (max-width: 1800px) {
  .card-width-app {
    width: 33.333333%;
  }
}

@media (max-width: 1300px) {
  .card-width-app {
    width: 50%;
  }
}
@media (max-width: 750px) {
  .card-width-app {
    width: 100%;
  }
}
</style>
